module.exports = "\r\n/* @import \"../../assets/plugins/bootstrap-select/css/bootstrap-select.css\"; */\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/E-comics/e-comic-series/e-comic-series.component.css
// module id = ./src/app/E-comics/e-comic-series/e-comic-series.component.css
// module chunks = main